module.exports = {
    "my.topic": "发布的帖子",
    "reply.topic": "评论的帖子",
    "his.topic": "TA发布的帖子",
    "pub.topic": "我发布的帖子"
}


// WEBPACK FOOTER //
// ./src/pages/myAnswer/i18n/locale.zh-cn.js